module.exports = __webpack_public_path__ + "bg_header.png?3c4afc335489e961878f2aef33edb4ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_header.png
// module id = 37
// module chunks = 0